<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">系统角色</div>
      <el-input
        v-model="RoleName"
        placeholder="请输入角色名称"
        class="nav-tree-filter"
      ></el-input>
      <div class="nav-tree-content" style="height: 50rem; overflow: auto">
        <el-tree
          style="height: 100%"
          :data="roleData"
          default-expand-all
          :filter-node-method="filterNode"
          @node-click="nodeClick"
          ref="roleTree"
          node-key="id"
          class="zj-demo-player-tree-device-tree"
        >
        </el-tree>
      </div>
    </zj-layout-header>
    <zj-layout-main></zj-layout-main>
  </zj-layout-container>
</template>
<script>
import permissionsApi from "../../../../../../request/permissionsApi";

export default {
  name: "PermissionRole",
  controller: "UI",
  action: "PermissionRole",
  props: {
    OnTreeSelected: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      RoleName: "",
      loading: false,
      loadingText: "加载中...",
      roleData: [],
      checkedKey: [],
    };
  },
  created() {
    this.getAppRole();
  },
  watch: {
    RoleName(val) {
      this.$refs.roleTree.filter(val);
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getAppRole() {
      this.loading = true;
      permissionsApi
        .findRolePage({ systemCode: this.CNF("app.perAppSystemCode"), page:1,size:100})
        .then((res) => {
          if (res.code == 0) {
             this.loading = false;
            if (res.data.length > 0) {
              this.roleData = this.convertToTreeNodesfunction(res.data);
            }
          } else {
            this.errmsg(res.msg);
          }
        }).catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var roleItem = list[i];
        var Role = {
          id: roleItem.code,
          label: roleItem.name,
          children: [],
        };

          result.push(Role);
      }
      let appRoles=[{id:"",label:this.CNF("app.appName"),children:result}];
      return appRoles;
    },
    nodeClick: function (data) {
      if (this.OnTreeSelected) this.OnTreeSelected(data);
    },
  },
};
</script>